import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=029af4ad&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=029af4ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029af4ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-develop-cn/s01_haiyiai_develop-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('029af4ad')) {
      api.createRecord('029af4ad', component.options)
    } else {
      api.reload('029af4ad', component.options)
    }
    module.hot.accept("./FAQ.vue?vue&type=template&id=029af4ad&scoped=true&", function () {
      api.rerender('029af4ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/renewalPackage/components/FAQ.vue"
export default component.exports